import { render, staticRenderFns } from "./Chatroom.vue?vue&type=template&id=cba94362&scoped=true&"
import script from "./Chatroom.vue?vue&type=script&lang=js&"
export * from "./Chatroom.vue?vue&type=script&lang=js&"
import style0 from "./Chatroom.vue?vue&type=style&index=0&id=cba94362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba94362",
  null
  
)

export default component.exports